import './handcraftedcatering/style';
import FormStructure from './handcraftedcatering/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js